import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { InputComponent } from "@components/input/input.component";
import { PageComponent } from "@components/page/page.component";
import { IRadiobuttonItem } from "@components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { TransportforetagSearchResultDTO } from "../../../common/models/kontakter/TransportforetagSearchResultDTO";
import { StatedataService, Volatile } from "../../../common/services/statedata.service";
import { TransportforetagService } from "./services/transportforetag.service";
import { TransportforetagListComponent } from "./transportforetag-list/transportforetag-list.component";

@Component({
    selector: "rask-transportforetag",
    templateUrl: "./transportforetag.component.html",
    styleUrls: ["./transportforetag.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        RadiobuttonGroupComponent,
        SubmitButtonComponent,
        TransportforetagListComponent
    ]
})
export class TransportforetagComponent implements OnInit {
    activetypes: IRadiobuttonItem[] = [
        {
            key: "ja",
            value: "Ja"
        },
        {
            key: "nej",
            value: "Nej"
        },
        {
            key: "alla",
            value: "Alla"
        }
    ];
    transportforetag: TransportforetagSearchResultDTO[];
    transportforetagForm = new UntypedFormGroup({
        searchtext: new UntypedFormControl(""),
        active: new UntypedFormControl("ja")
    });
    volatile: Volatile;

    private readonly WIK = "transportforetag.search";
    private readonly raskBusy = inject(BusyService);
    private readonly statedataService = inject(StatedataService);
    private readonly transportforetagService = inject(TransportforetagService);

    constructor() {
        this.volatile = this.statedataService.getVolatile();
    }

    ngOnInit() {
        const stateData = this.volatile.get<any>(this.WIK);
        if (stateData) {
            this.transportforetagForm.get("searchtext").setValue(stateData.searchtext);
            this.transportforetagForm.get("active").setValue(this.parseActiveState(stateData.active));
            this.searchfunc(stateData.searchtext, stateData.active);
        }
    }

    parseActiveState(val = false) {
        if (!val) {
            return "alla";
        }
        return val ? "ja" : "nej";
    }

    parseActiveText(val: string) {
        if (!val || val === "alla") {
            return null;
        }
        return val === "ja";
    }

    search() {
        const searchtext = this.transportforetagForm.get("searchtext").value;
        const active = this.parseActiveText(this.transportforetagForm.get("active").value);
        this.searchfunc(searchtext, active);
    }

    searchfunc(searchtext: string, active = false) {
        this.raskBusy.addWork(this.transportforetagService.search(searchtext, active)).subscribe(result => {
            this.transportforetag = result;
            this.volatile.set(this.WIK, {
                searchtext: searchtext,
                active: active
            });
        });
    }
}
